// ============================================================================
// JamCam Feature Resolution
// Maps entitlement status → concrete feature flags
// ============================================================================

import { EntitlementStatus, JamCamFeatures } from './types';

const FREE_FEATURES: JamCamFeatures = {
  canRecord: true,
  canExport: false,
  canUseAI: false,
  maxStorageMB: 500,
  maxSessionsPerDay: 3,
};

const PRO_FEATURES: JamCamFeatures = {
  canRecord: true,
  canExport: true,
  canUseAI: true,
  maxStorageMB: 50_000,
  maxSessionsPerDay: -1, // unlimited
};

export function resolveFeatures(
  entitlementStatus: EntitlementStatus
): JamCamFeatures {
  switch (entitlementStatus) {
    case 'paid':
    case 'trial':
    case 'grace':
      return { ...PRO_FEATURES };
    case 'free':
    case 'blocked':
    default:
      return { ...FREE_FEATURES };
  }
}
